import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { MatCheckboxModule } from '@angular/material/checkbox';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    IonicModule,
    MatCheckboxModule,
  ],
  selector: 'app-weekday-selector',
  templateUrl: './weekday-selector.component.html',
  styleUrls: ['./weekday-selector.component.scss'],
})
export class WeekdaySelectorComponent implements OnInit {
  @Input() initialValue?: string;
  @Input() daysInput?: string[];
  @Input() uiFramework: 'ionic' | 'material' = 'ionic';
  @Output() valueChange = new EventEmitter<string>();

  days: string[] = [];
  selectedDays: boolean[] = [];

  ngOnInit() {
    this.days = (this.daysInput && this.daysInput.length === 7)
      ? this.daysInput
      : ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
    this.selectedDays = this.initialValue?.split('').map((bit) => bit === '1') ?? [false, false, false, false, false, false, false];
  }

  onDayChange(index: number) {
    this.selectedDays[index] = !this.selectedDays[index];
    this.valueChange.emit(this.selectedDays.map((selected) => selected ? '1' : '0').join(''));
  }
}
